
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/analytics-new/engagement",
      function () {
        return require("private-next-pages/admin/analytics-new/engagement.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/analytics-new/engagement"])
      });
    }
  